import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // ✅ Added
import { logInteraction } from '../utils/tracker.js'; // ✅ Add .js
import '../styles.css';
import { Helmet } from 'react-helmet-async'; // Updated import
import { getMetadataBundleForStaticPage } from '../metadata/SEOmetadata.js';
import useWindowSize from '../hooks/useWindowSize.js'; // ✅ Add .js
import { t } from '../i18n/translationStrings.js'; // <-- added import

const CategoriesPage = () => {
    const categories = [
  "Adventure", "Africa", "African American", "Alchemy", "American Civil War", "American History",
  "American Literature", "Anarchism", "Ancient Greece", "Anthology", "Anthropology", "Architecture",
  "Art", "Asian History", "Astrology", "Astronomy", "Atheism and Agnosticism", "Biographies", "Biology",
  "Botany", "British Literature", "Buddhism", "Business", "Catholic", "Central and Northern Asia",
  "Chemistry", "Children's Literature", "Christianity", "Colonialism", "Conservatives and Reactionaries",
  "Correspondence", "Criticism", "Death and Dying", "Decadence", "Design", "Detective",
  "Divination", "Drama & Theatre", "Drugs and Addiction", "Dystopian Literature", "East Asia", "Economics",
  "Education", "Enlightenment", "Epistemology", "Eros and Sexuality", "Essays", "Ethics",
  "Ethnology and Ethnographies", "Existentialism", "Fantasy and Fairy tales", "Fashion", "Feminism",
  "Film and Photography", "Food and Drink", "French Literature", "German Idealism", "Gothic Literature",
  "Heresy", "Hinduism", "Historical Fiction", "History", "Horror", "Idealism", "International Relations",
  "Islam", "Judaism", "Law & Justice", "Liberalism", "Literature", "Logic", "Magic", "Marxism and Socialism",
  "Mathematics", "Medicine", "Meditation", "Medieval", "Middle East", "Military Theory",
  "Modernist Literature", "Music", "Mysteries", "Mysticism", "Mythology & Folklore", "Napoleonic", "Nationalism",
  "Norse", "Novel", "Occultism and Esotericism", "Pagan", "Paranormal", "Philosophy", "Philosophy of History",
  "Philosophy of Science", "Physics", "Physiology", "Poetry", "Political Economy", "Political Philosophy",
  "Politics", "Practical Manuals", "Psychoanalysis", "Psychology", "Realism", "Religion", "Renaissance",
  "Rhetoric", "Romance", "Roman - Empire and Republic", "Romanticism", "Russian Literature", "Satire",
  "Scandinavia", "Science", "Science Fiction", "Short Stories", "Social Philosophy", "Sociology",
  "South America", "South Asia", "Southeast Asia", "Spirituality", "Sports", "Sufism", "Surrealism",
  "Technology", "Theology", "Theosophy", "Tragedy", "Transcendentalism", "Travel", "Utopia", "Vitalism",
  "World War 1", "Zoology"
];

    const windowWidth = useWindowSize(); // Replaced manual window resize logic

    // 🔎 DEBUG: confirm this page actually mounts
    useEffect(() => {
        console.log('[ROUTE] CategoriesPage mounted');
        return () => console.log('[ROUTE] CategoriesPage unmounted');
    }, []);

    // Log when the page is viewed
    useEffect(() => {
        logInteraction('page_view', { page: 'Categories' });
    }, []);
    
    const pageMetadata = getMetadataBundleForStaticPage('categories');

    // Group categories alphabetically by TRANSLATED value
    const groupedCategories = categories.reduce((acc, category) => {
        const translated = t(category);
        const firstLetter = translated[0].toUpperCase();
        if (!acc[firstLetter]) acc[firstLetter] = [];
        acc[firstLetter].push(category);
        return acc;
    }, {});
    
    // For UI, sort items by TRANSLATED label
    Object.keys(groupedCategories).forEach(letter => {
        groupedCategories[letter].sort((a, b) =>
            t(a).localeCompare(t(b), undefined, { sensitivity: 'base' })
        );
    });

    // ✅ Log category selection
    const handleCategoryClick = (category) => {
        logInteraction('category_selection', { categoryName: category });
    };

    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: windowWidth < 768 ? 'repeat(2, 1fr)' : 'repeat(6, 1fr)',
        gap: '10px',
        padding: '1rem',
        maxWidth: '1200px',
        margin: '0 auto',
    };

    const headerStyle = {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        marginTop: '2rem',
        marginBottom: '1rem',
        color: 'var(--highlight-color)',
    };

    const categoryStyle = {
        fontSize: '0.9rem',
        textAlign: 'center',
        padding: '0.5rem',
        border: '1px solid var(--light-gray)',
        borderRadius: '6px',
        backgroundColor: 'var(--dark-gray)',
        color: 'var(--text-color)',
        cursor: 'pointer',
        transition: 'background-color 0.2s, color 0.2s',
    };

    return (
        <main className="categories-container">
            <Helmet>
                <html lang={pageMetadata.htmlLang || 'en'} />
                <title>{pageMetadata.title || 'Hermes Reads – Categories'}</title>
                <meta name="description" content={pageMetadata.description || 'Browse categories on Hermes Reads'} />
                <meta name="keywords" content={Array.isArray(pageMetadata.keywords) ? pageMetadata.keywords.join(', ') : pageMetadata.keywords || ''} />
                <meta property="og:image" content={pageMetadata.ogImage || '/images/PlaceholderJPG.webp'} />
                <link rel="canonical" href="https://www.hermesreads.com/categories" />
            </Helmet>

            <section className="category-list container">
                <h2 style={{ textAlign: 'center' }}>{t("browseByCategory")}</h2>
                {Object.keys(groupedCategories).sort().map((letter) => (
                    <div key={letter}>
                        <h3 style={headerStyle}>{letter}</h3>
                        <ul className="language-grid" style={gridStyle}>
                            {groupedCategories[letter].map((category) => (
                                <li key={category} style={categoryStyle}>
                                    <Link
                                        to={`/genre/${encodeURIComponent(category.trim().toLowerCase())}`}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                        onClick={() => handleCategoryClick(category)} // ✅ Logs click
                                    >
                                        {t(category)}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </section>
        </main>
    );
};

export default CategoriesPage;
